import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import FormsyForm from 'formsy-react'
import PropTypes from 'prop-types'
import strictUriEncode from '../../strict-uri-encode/index'
import { historyRedirect } from '../../services/navigation/index'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../Page/connect'
import { connect as connectStaticText } from '../StaticText/connect'
import { getBoundActions } from '../../actions/index'
import { TYPE_LOGIN } from '../../services/dialog/index'
import { getAuthIsLoggedIn } from '../../services/auth/index'
import { URL_LOGOUT } from '../../services/url/constants'
import Button, { TYPES } from '../Button/index'
import { H1 } from '../Heading/index'
import { SHOPIFY_MULTIPASS_ERROR_MESSAGE } from '../../services/auth/actions'

function ShopifyMultipassLoginPage (props) {
  const {
    staticText,
    auth,
    user,
    history,
    getShopifyMultipassToken,
    resolver,
  } = props

  const logout = () => {
    const language = user.getIn(['data', 'language', 0], 'en')
    const redirectFromQuerystring = resolver.getIn(['query', 'redirect'], null)
    const redirect = redirectFromQuerystring ? `mp-login?redirect=${strictUriEncode(redirectFromQuerystring)}` : 'mp-login'
    historyRedirect({
      query: { redirect },
      url: URL_LOGOUT,
      language,
      history,
      auth,
    })
  }

  const renderDescription = () => {
    const {
      setOverlayDialogVisible,
    } = props
    if (!getAuthIsLoggedIn(auth)) {
      return (
        <FormsyForm
          className="shopify-multipass__form"
          key="shopify-multipass-form-not-authenticated"
        >
          <p className="shopify-multipass__description" key="shopify-multipass-description">
            { staticText.getIn(['data', 'mainDescriptionNotAuthenticated']) }
          </p>
          <div className="shopify-multipass__buttons">
            <Button
              type={TYPES.PRIMARY}
              onClick={function _confirmAuth () {
                setOverlayDialogVisible(TYPE_LOGIN)
              }}
            >
              {staticText.getIn(['data', 'login'])}
            </Button>
          </div>
        </FormsyForm>
      )
    }
    return null
  }

  const renderErrorMessage = () => {
    const errorMessage = auth.get(SHOPIFY_MULTIPASS_ERROR_MESSAGE)
    if (errorMessage) {
      const fullMessage = `${staticText.getIn(['data', 'marketplaceLoginError'])} : ${errorMessage}`
      return (<p key="shopify-multipass-error" className={'shopify-multipass__error'}>
        {fullMessage}
      </p>)
    }
    return null
  }

  const renderAuth = () => {
    if (!getAuthIsLoggedIn(auth)) {
      return null
    }
    const redirectFromQuerystring = resolver.getIn(['query', 'redirect'], null)

    return (
      <FormsyForm
        className="shopify-multipass__form"
        key="shopify-multipass-form"
      >
        <p key="shopify-multipass-auth-label" className="shopify-multipass__label">
          { staticText.getIn(['data', 'youAreLoggedInAs']) }
          <span key="shopify-multipass-username" className="shopify-multipass__username">
            {auth.get('username')}
          </span>
        </p>
        <div className="shopify-multipass__buttons">
          <Button
          className="shopify-multipass__button-access"
            type={TYPES.PRIMARY}
            onClick={function _confirmAuth () { getShopifyMultipassToken(redirectFromQuerystring) }}
          >
            {staticText.getIn(['data', 'accessMarketplace'])}
          </Button>
          <Button
            type={TYPES.SECONDARY}
            onClick={function _logout () { logout(props) }}
          >
            {staticText.getIn(['data', 'loginAsADifferentUser'])}
          </Button>
        </div>
      </FormsyForm>
    )
  }

  const renderContent = () => {
    return [
      renderDescription(),
      renderAuth(),
      renderErrorMessage(),
    ]
  }

  return (
    <div className="shopify-multipass">
      <div className="shopify-multipass__jumbotron">
        <H1 className="shopify-multipass__jumbotron-title">
          {staticText.getIn(['data', 'gaiaMarketplace'])}
        </H1>
      </div>
      <div className="shopify-multipass__content-wrapper">
        <div className="shopify-multipass__content">
          {renderContent()}
        </div>
      </div>
    </div>
  )
}

ShopifyMultipassLoginPage.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  setOverlayDialogVisible: PropTypes.func.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  getShopifyMultipassToken: PropTypes.func.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectStaticText({ storeKey: 'shopifyMultipassLoginPage' }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
        getShopifyMultipassToken: actions.auth.getShopifyMultipassToken,
      }
    },
  ),
)(ShopifyMultipassLoginPage)
